import { render, staticRenderFns } from "./ArrangeForServiceWrInstructions.vue?vue&type=template&id=06c89adc"
import script from "./ArrangeForServiceWrInstructions.vue?vue&type=script&lang=ts"
export * from "./ArrangeForServiceWrInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports